/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import {
  FETCH_ACES_CHAP_BURIAL_PROVIDER_SEARCH,
  FETCH_ACES_CHAP_INSURANCE_PROVIDER_SEARCH,
} from './actionTypes';

/**
 * Updates the details in the 'ACESProviderSearch' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchAcesChapBurialProviderSearchReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_ACES_CHAP_BURIAL_PROVIDER_SEARCH);

/**
 * Updates the indicator of creation of details in the 'ACESProviderSearch' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchAcesChapBurialProviderSearchReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_ACES_CHAP_BURIAL_PROVIDER_SEARCH);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchAcesChapBurialProviderSearchErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_ACES_CHAP_BURIAL_PROVIDER_SEARCH);

/**
 * Updates the details in the 'ACESProviderSearch' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchAcesChapInsuranceProviderSearchReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_ACES_CHAP_INSURANCE_PROVIDER_SEARCH);

/**
 * Updates the indicator of creation of details in the 'ACESProviderSearch' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchAcesChapInsuranceProviderSearchReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_ACES_CHAP_INSURANCE_PROVIDER_SEARCH);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchAcesChapInsuranceProviderSearchErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_ACES_CHAP_INSURANCE_PROVIDER_SEARCH);

const reducers = combineReducers({
  fetchAcesChapBurialProviderSearch: fetchAcesChapBurialProviderSearchReducer,

  isFetchingFetchAcesChapBurialProviderSearch: isFetchingFetchAcesChapBurialProviderSearchReducer,
  fetchAcesChapBurialProviderSearchError: fetchAcesChapBurialProviderSearchErrorReducer,

  fetchAcesChapInsuranceProviderSearch: fetchAcesChapInsuranceProviderSearchReducer,

  isFetchingFetchAcesChapInsuranceProviderSearch:
    isFetchingFetchAcesChapInsuranceProviderSearchReducer,
  fetchAcesChapInsuranceProviderSearchError: fetchAcesChapInsuranceProviderSearchErrorReducer,
});

export default { reducers };
